import { styled } from "@mui/material/styles"

export const StyledFeaturedCollectionsContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column"
}))

export const StyledFeaturedCollections = styled("div")(() => ({}))
